<script>
export default {
  name: 'MainToggler',
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    telephoneHref(tel) {
      return 'tel:' + tel.replace(/\s/g, '');
    },
    toggle() {
      window.EventBus.fire('main-navigation-toggled', (this.opened = !this.opened));
    },
  },
  render() {
    return this.$scopedSlots.default({
      opened: this.opened,
      toggle: this.toggle,
      telephoneHref: this.telephoneHref,
    });
  },
};
</script>
